import { color } from './color.js';
export const font = {
    size: {
        xxl: '3rem',
        xl: '2.25rem',
        lg: '1.5rem',
        md: '1.25rem',
        sm: '1rem',
        xs: '.875rem',
        xxs: '.75rem',
    },
    color: {
        base: color.gray60,
        primary: color.gray90,
        secondary: color.gray50,
    },
};
//# sourceMappingURL=font.js.map